import { FC, lazy, Suspense, useMemo } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useLocation } from '../../context/LocationContext';
import { createDigitalBillOverviewUrl } from '../../utils/linkBuilder';
import { isAdyenDevice } from '../../utils/isAdyenDevice';
import Spinner from '../../components/Spinner';

const SettledBillsPage = lazy(() => import('./settled/SettledBillsPage'));
const UnsettledBillsPage = lazy(() => import('./unsettled/UnsettledBillsPage'));
const LowEndUnsettledBillsPage = lazy(() => import('./unsettled/LowEndUnsettledBillsPage'));

const DigitalBillSwitch: FC = () => {
  const { location } = useLocation();

  const unsettledBillComponent = useMemo(() => {
    return isAdyenDevice() ? <LowEndUnsettledBillsPage /> : <UnsettledBillsPage />;
  }, []);

  return (
    <main className="h-main grid tablet:grid-cols-12 auto-rows-min tablet:auto-rows-auto bg-grey-lightest">
      <Suspense fallback={<Spinner className="m-auto mt-6 w-8 h-8" />}>
        <Routes>
          <Route path="settled/*" element={<SettledBillsPage />} />
          <Route path="unsettled/*" element={unsettledBillComponent} />
          <Route path="*" element={<Navigate to={createDigitalBillOverviewUrl(location.locationId)} replace />} />
        </Routes>
      </Suspense>
    </main>
  );
};

export default DigitalBillSwitch;
